import React, { useState, useEffect } from 'react';
import { deleteDocumentsForSummary, getUploadedDocumentsForSummary, uploadDocumentsForSummary } from '../../../../common/services/http.service';
import { validateFileAndGetFormData } from '../../../../common/utils/validator';
import upload_icon from '../../images/upload_icon.svg';
import uploading_icon from '../../images/uploading.svg';
import FileSaver from 'file-saver';
import { GENERIC_ERROR_MESSAGE } from 'common/constants/app.constants';
import { getFileName } from 'home/view/manage-feasibility/utils';
import './fileUpload.scss';
const FileUpload = ({ onFileUploadSuccess, label, supportedLabel, limitLabel, fileSchema, multiple, type, isFileHaveValue, fileArray, isOrderConfirmation = false }) => {
  const [isUploaded, setIsUploaded] = useState(isFileHaveValue ? true : false);
  const [error, setError] = useState({ state: false, message: '' });
  const [files, setFiles] = useState(isFileHaveValue ? fileArray : []);
  const [progressValue, setProgressValue] = useState(0);
  useEffect(() => {
    if (files && files.length > 0 && isUploaded) {
      onFileUploadSuccess('success', type);
    } else {
      onFileUploadSuccess('', type);
    }
  }, [isUploaded]);

  const onUploadProgress = (progressEvent) => {
    const loadingPercentage = (progressEvent.loaded / progressEvent.total) * 100;
    setProgressValue(loadingPercentage - 5);
  };

  const myFileUpload = (event) => {
    const { isFilesValid, formData, errorMessage, filesMetaData } = validateFileAndGetFormData({ event, ...fileSchema, files });

    if (isFilesValid) {
      const uploadedFiles = [...files, ...Array.from(filesMetaData)];
      setFiles(uploadedFiles);
      setError({ state: false, message: '' });
      uploadDocumentsForSummary(formData, onUploadProgress).then(
        (resp) => {
          setProgressValue(100);
          setIsUploaded(true);
          setTimeout(() => setProgressValue(0));
        },
        (error) => {
          setIsUploaded(false);
          setFiles([]);
          setProgressValue(0);
          console.log(error);
          const errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
          setError({
            state: true,
            message: errorMsg
          });
        }
      );
    } else {
      setError({
        state: true,
        message: errorMessage
      });
    }
  };

  const getUploadedFile = (documentName, type) => {
    const payload = { documentType: fileSchema.documentType, documentName };
    getUploadedDocumentsForSummary(payload).then(
      (response) => {
        const { data } = response;

        const file = new Blob([data], { type });

        // view files in new tab
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');

        // for downloading files
        // const fileName = getFileName(response, 'Download.pdf');
        // const file = new Blob([data], { type });
        // FileSaver.saveAs(file, fileName);
      },
      (err) => {
        console.error(err);
        setError({
          state: true,
          message: 'Error while opening files'
        });
      }
    );
  };

  const onDeleteUploadedFile = (fileName, documentName) => {
    const payload = { documentType: fileSchema.documentType, documentName };
    setError({ state: false, message: '' });
    deleteDocumentsForSummary(payload).then(
      (resp) => {
        const leftFiles = files.filter(({ documentName: fileDocumentName }) => fileDocumentName !== documentName);
        setFiles(leftFiles);
        if (leftFiles.length === 0) {
          setIsUploaded(false);
        }
      },
      (err) => {
        console.error(err);
        setError({
          state: true,
          message: 'Error while deleting files'
        });
      }
    );
  };

  const renderUploadedFiles = () => {
    return files.map(({ name, size, type, documentName }, index) => {
      return (
        <div className="file_content" key={name + index}>
          <span className="file_icon">
            <img src={uploading_icon} alt="Uploading" />
          </span>
          <a className="name_text" role="button" href onClick={getUploadedFile.bind(null, documentName, type)}>
            {name}
          </a>
          {!isOrderConfirmation && <span className="cross_icon" onClick={onDeleteUploadedFile.bind(null, name, documentName)}></span>}
        </div>
      );
    });
  };

  const getListOfFiles = () => {
    return files.map(({ name }) => name).join(', ');
  };

  return (
    <React.Fragment>
      {
        <React.Fragment>
          {error.state && <div className="msg_strip strip_error">Error: {error.message}</div>}

          {!error.state && isUploaded && <div className="msg_strip strip_success">{getListOfFiles()} successfully uploaded</div>}

          {
            <div className="upload_status">
              <ul className="attach_types">
                <li> {label}</li>
                <li> {supportedLabel} </li>
                <li> {limitLabel} </li>
              </ul>
              {files?.length < fileSchema?.documentNames?.length && (
                <div className="file_upload_area">
                  <div className="select_files">
                    <span class="upload_file_iocn">
                      <img src={upload_icon} alt="Upload" />
                    </span>
                    <div className="upload_text">
                      Drag a file here to attach or <span class="link">browse</span>
                    </div>
                    {multiple ? (
                      <input className="upload_field" type="file" onChange={myFileUpload} accept={fileSchema.supportedTypes.join(',')} multiple />
                    ) : (
                      <input className="upload_field" type="file" onChange={myFileUpload} accept={fileSchema.supportedTypes.join(',')} />
                    )}
                  </div>
                </div>
              )}
              <div className="progress_bar">
                <div className="progress_line" style={{ width: `${progressValue}%` }}></div>
              </div>

              {isUploaded && renderUploadedFiles()}
            </div>
          }
        </React.Fragment>
      }
    </React.Fragment>
  );
};

export default FileUpload;
